module.exports = {
      id: "generate-usage",
      viewBox: "0 0 16 14",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#generate-usage",
      toString: function () {
        return this.url;
      }
    }